var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "object-menu-container",
      style: [_vm.xPosition, _vm.yPosition],
      attrs: { "data-app": "" }
    },
    [
      _c(
        "v-list",
        { staticClass: "pa-0", attrs: { subheader: "" } },
        _vm._l(_vm.menuItems, function(item) {
          return item.visible
            ? _c(
                "v-list-item",
                {
                  key: item.title,
                  staticStyle: { height: "30px", "min-height": "35px" },
                  attrs: { disabled: item.disabled },
                  on: {
                    click: function($event) {
                      return _vm.executeAction(item.id)
                    }
                  }
                },
                [
                  _c("v-icon", { staticClass: "mr-3", attrs: { size: "15" } }, [
                    _vm._v(_vm._s(item.icon))
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "pr-2",
                      staticStyle: { "font-size": "10px" }
                    },
                    [_vm._v(_vm._s(item.title))]
                  )
                ],
                1
              )
            : _vm._e()
        }),
        1
      ),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("Delete"),
          content: _vm.deleteDialogMessage,
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes"),
          loading: _vm.loadingDelete
        },
        on: {
          mainAction: _vm.cancelDelete,
          secondaryAction: _vm.confirmOpenSecondDialog
        }
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.secondDeleteDialog,
          title: _vm.$t("Delete"),
          content: _vm.deletecableWithClosure,
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes"),
          loading: _vm.loadingDelete
        },
        on: {
          mainAction: _vm.cancelDelete,
          secondaryAction: function($event) {
            return _vm.confirmDelete("?deleteCluster=true")
          }
        }
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.joinCablesDialog,
          title: _vm.$t("Join") + " " + _vm.$tc("Cable", 2),
          content: _vm.joinCablesDialogMessage,
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes"),
          loading: _vm.loadingDelete
        },
        on: {
          mainAction: _vm.cancelDelete,
          secondaryAction: function($event) {
            return _vm.confirmDelete("?join_cables=true")
          }
        }
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.joinPathwayWhenDeleteTP.open,
          title: _vm.joinPathwayWhenDeleteTP.title,
          content: _vm.joinPathwayWhenDeleteTP.content,
          "main-action-label": _vm.$t("Yes"),
          "secondary-action-label": _vm.$t("No"),
          loading: _vm.loadingDelete
        },
        on: {
          mainAction: _vm.confirmJoinPathwayOrDeleteTP,
          secondaryAction: function($event) {
            _vm.joinPathwayWhenDeleteTP.open = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-delete-cable-when-delete-cluster", {
        attrs: {
          open: _vm.deleteCablesWhenDeleteClusterDialog,
          loading: _vm.loadingDelete
        },
        on: {
          cancel: function($event) {
            _vm.deleteCablesWhenDeleteClusterDialog = false
          },
          "delete-cables-created-automatically": function($event) {
            return _vm.confirmDelete("?cablesToDelete=only_automatic")
          },
          "delete-all-cables": function($event) {
            return _vm.confirmDelete("?cablesToDelete=all_cables")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67b9adf9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67b9adf9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectMenu/ObjectMenu.vue
// module id = null
// module chunks = 